import { library } from "@fortawesome/fontawesome-svg-core";

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - This will fail to find corresponding type declarations unless compilerOptions.moduleResolution is set to "bundler" in tsconfig.json.
// But "bundler" was added in TypeScript 5 and we are still on TypeScript 4. TODO: Once updraded to TS5, set compilerOptions.moduleResolution to "bundler" and remove this comment.
import { all } from "@awesome.me/kit-b56161fd23/icons";

export type IconVariant = "solid" | "regular" | "light" | "duotone" | "brands";

export function addAllIconsToLibrary(): void {
	library.add(all);
}
